import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FollowIcon from '../../../common/components/FollowIcon';
import {DataDtmActions} from '../../../common/Constants';
import Classes from '../../../common/Classes';
import ExhibitorDetailService from '../../../exhibitorHub/api/ExhibitorDetailService';
import MediaQuery from 'react-responsive';

class FollowComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFollowed: props.isFollowed
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFollowed !== this.props.isFollowed) {
      this.setIsFollowed(this.props.isFollowed);
    }
  }

  setIsFollowed(isFollowed) {
    this.setState({ isFollowed });
  }

  handleClick = () => {
    ExhibitorDetailService.followOrUnfollowOrganisation(
      this.props.baseApiUrl, this.props.locale,
      this.props.digitalPortfolioId, this.props.organisationId, this.state.isFollowed
    ).then((serviceResult) => {
      if (serviceResult) {
        this.setState({ isFollowed: !this.state.isFollowed });
        if (this.props.handleFollowClick !== undefined) {
          this.props.handleFollowClick(this.props.organisationId, this.state.isFollowed);
        }
      }
    });
  };

  render() {
    const altSVG = this.state.isFollowed ? this.props.translations.removeCompanyFromNetwork :
      this.props.translations.addCompanyToNetwork;

    const dtmTag = () => {
      const dtmTagVal = this.state.isFollowed ? this.props.dtmData.unFollowIcon : this.props.dtmData.followIcon;
      return this.props.isPrioritySlotPremiumExhibitor ? dtmTagVal + this.props.dtmData.prioritySlot : dtmTagVal;
    }

    return (
      <div className={Classes.showPlanContainer} data-testid="follow-component-container">
        <div
          className={classnames(Classes.exhibitorDetailsInfo, Classes.primaryButton)}
          role="button"
          tabIndex={0}
          data-dtm={dtmTag()}
          data-dtm-action={DataDtmActions.click}
          data-dtm-attributes={JSON.stringify({
            organisationId: this.props.organisationId,
            userId: this.props.userId,
            exhibitorId: this.props.exhibitingOrganisationId,
          })}
          onClick={this.props.handleClick !== undefined ? this.props.handleClick : this.handleClick}
        >
          <span className={Classes.ExhibitorDetailIcons}>
            <FollowIcon
              isFollowed={this.state.isFollowed}
              altSVG={altSVG}
              locale={this.props.locale}
            />
          </span>
          <MediaQuery minWidth={768} maxWidth={1197}>
            <span className={Classes.singleLineEllipsis}>{this.state.isFollowed ? this.props.translations.removeCompanyFromNetwork :
              this.props.translations.addCompanyToNetwork }
            </span>
          </MediaQuery>
          <MediaQuery minWidth={1198}>
            <span className={Classes.singleLineEllipsis}>{this.state.isFollowed ? this.props.translations.removeCompanyFromNetworkShortened :
              this.props.translations.addCompanyToNetworkShortened }
            </span>
          </MediaQuery>
        </div>
      </div>
    );
  }
}

FollowComponent.propTypes = {
  isFollowed: PropTypes.bool.isRequired,
  translations: PropTypes.object.isRequired,
  locale: PropTypes.string,
  baseApiUrl: PropTypes.string,
  digitalPortfolioId: PropTypes.string,
  organisationId: PropTypes.string.isRequired,
  handleFollowClick: PropTypes.func,
  dtmData: PropTypes.object,
  userId: PropTypes.string,
  handleClick: PropTypes.func,
  exhibitingOrganisationId: PropTypes.string.isRequired,
  isPrioritySlotPremiumExhibitor: PropTypes.bool,
};

export default FollowComponent;
